export const HEADER = [
    { title: 'ПЕРИОД ПРОВЕДЕНИЯ', fieldName: '' },
    { title: 'СПЕЦИАЛЬНОСТЬ', fieldName: '' },
    { title: 'ТРЕБУЕТСЯ', fieldName: '' },
];
